"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIScoreSchemaV3 = exports.ScoreSubjectV3 = void 0;
const zod_1 = require("zod");
const scores_1 = require("../../../../../domain/scores");
// Discriminated on `kind` so the type system enforces that `traceId` is
// only ever present on the observation arm — matches the Fern union and
// the deriveSubject runtime contract.
exports.ScoreSubjectV3 = zod_1.z.discriminatedUnion("kind", [
    zod_1.z.object({
        kind: zod_1.z.literal("trace"),
        id: zod_1.z.string(),
    }),
    zod_1.z.object({
        kind: zod_1.z.literal("observation"),
        id: zod_1.z.string(),
        traceId: zod_1.z.string().optional(),
    }),
    zod_1.z.object({
        kind: zod_1.z.literal("session"),
        id: zod_1.z.string(),
    }),
    zod_1.z.object({
        kind: zod_1.z.literal("experiment"),
        id: zod_1.z.string(),
    }),
]);
/**
 * Foundation schema for scores API v3.
 *
 * Must be extended with a dataType-specific value shape.
 *
 * Unlike v1/v2, v3 returns the score's value as a single polymorphic field
 * (number | boolean | string) rather than the dataType-split
 * `value` / `stringValue` / `longStringValue` triple.
 */
const ScoreFoundationSchemaV3 = zod_1.z.object({
    id: zod_1.z.string(),
    projectId: zod_1.z.string(),
    name: zod_1.z.string(),
    source: scores_1.ScoreSourceDomain,
    timestamp: zod_1.z.coerce.date(),
    environment: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    // optional groups
    comment: zod_1.z.string().nullable().optional(),
    configId: zod_1.z.string().nullable().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    authorUserId: zod_1.z.string().nullable().optional(),
    queueId: zod_1.z.string().nullable().optional(),
    subject: exports.ScoreSubjectV3.optional(),
});
exports.APIScoreSchemaV3 = zod_1.z.discriminatedUnion("dataType", [
    ScoreFoundationSchemaV3.extend({
        dataType: zod_1.z.literal("NUMERIC"),
        value: zod_1.z.number(),
    }),
    ScoreFoundationSchemaV3.extend({
        dataType: zod_1.z.literal("BOOLEAN"),
        value: zod_1.z.boolean(),
    }),
    ScoreFoundationSchemaV3.extend({
        dataType: zod_1.z.literal("CATEGORICAL"),
        value: zod_1.z.string(),
    }),
    ScoreFoundationSchemaV3.extend({
        dataType: zod_1.z.literal("TEXT"),
        value: zod_1.z.string(),
    }),
    ScoreFoundationSchemaV3.extend({
        dataType: zod_1.z.literal("CORRECTION"),
        value: zod_1.z.string(),
    }),
]);
